import { FeatureToggleV2Type, formatToCommaWithLang, t, useFeatureToggleV2, usePlayerStore } from '@slot-nx/core'
import { Container, Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'

export const VoucherHeaderPayout = (props: { totalPayout: number }) => {
  const currency = usePlayerStore(x => x.currency)
  const displayCurrency = useFeatureToggleV2(FeatureToggleV2Type.displayCurrency)
  const displayPayoutStr = displayCurrency
    ? `${currency}  ${formatToCommaWithLang(props.totalPayout)}`
    : `${formatToCommaWithLang(props.totalPayout)}`

  return (
    <Container name="VoucherHeaderPayout">

      <Text
        text={t('voucher_header_payout_title')}
        x={825}
        y={30}
        anchor={[0.5, 0.5]}
        name="WIN"
        style={new TextStyle({
          align: 'center',
          fontWeight: '600',
          fill: '#FFBF00',
          fontFamily: 'Roboto',
          fontSize: 27,
        })}
      />

      <Text
        text={displayPayoutStr}
        x={825}
        y={70}
        anchor={[0.5, 0.5]}
        name="payout"
        style={new TextStyle({
          align: 'center',
          fontWeight: 'normal',
          fill: '#FFFFFF',
          fontFamily: 'RobotoCondensed',
          fontSize: 35,

        })}
      />

    </Container>

  )
}
